<template>
<div class='setting-form'>
  <el-form class='settings-form' label-width="120px">
    <el-input style="display: none;"></el-input>
    <router-link class='reupload-btn el-tabs__item' :to="{name: 'project_upload', params: { id: project.id }}" v-if="!expired && !locked && !readonly">
      <i class='ppj-icon-up-big'></i>更新PPT
    </router-link>
    <el-tabs class='tabs' theme='info' :value="tbcMode ? 'third' : 'first'">
      <el-tab-pane label="常用设置" name="first" v-if="!tbcMode">
        <!-- 微信分享 -->
        <el-form-item :label="$t('actions.project.settings.wxshare')" class='wechat-share'>
          <image-uploader v-model="cover" :title="$t('actions.project.settings.wxcover')" tag='cover' class="cover-wrapper" />
          <div class='inputs'>
            <el-input :placeholder="$t('placeholder.project.title')" v-model="form.title"></el-input>
            <el-input type="textarea" :rows='3' resize='false' :placeholder="$t('placeholder.project.description')" v-model="form.description"></el-input>
          </div>
        </el-form-item>

        <!-- 背景音乐 -->
        <bgm-setting v-model='bgmSetting' ref='bgm-setting' />

        <!-- LOGO 设置 -->
        <logo-setting :editable="form.allow_to_modify_logo" ref='logo-setting' v-model='logoSetting' />

        <!-- 发布设置 -->
        <permanent-setting ref='permanent-setting' />
      </el-tab-pane>

      <el-tab-pane label="高级设置" name='second' v-if="!tbcMode">
        <!-- 翻页箭头 -->
        <el-form-item :label="$t('actions.project.settings.arrow')">
          <el-switch class='arrow-switch' :width="35" theme='info' on-text='' off-text='' v-model="arrowMode"></el-switch>
        </el-form-item>

        <!-- 翻页控制 -->
        <el-form-item label="翻页控制" class='tansition-ctrl'>
          <el-radio-group theme='info' v-model='form.transition_ctrl'>
            <el-radio-button label='click'>
              默认手动
            </el-radio-button>
            <el-radio-button label='strict'>
              还原PPT
            </el-radio-button>
          </el-radio-group>
        </el-form-item>

        <!-- 动画控制 -->
        <el-form-item :label="$t('actions.project.settings.autoplayLabel')" class='auto-play'>
          <el-radio-group theme='info' v-model='form.auto_play'>
            <el-radio-button label='enabled'>
              {{$t('actions.project.settings.autoplay.enabled')}}
            </el-radio-button>
            <el-radio-button label='original'>
              {{$t('actions.project.settings.autoplay.original')}}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>

        <!-- 页面适配 -->
        <!--
        <el-form-item :label="$t('actions.project.settings.stretch')" class='page-setup'>
          <el-radio-group theme='info' v-model='form.stretch_mode'>
            <el-radio-button label='auto'>
              {{$t('actions.project.settings.stretchValue.auto')}}
            </el-radio-button>
            <el-radio-button label='fullscreen'>
              {{$t('actions.project.settings.stretchValue.fullscreen')}}
            </el-radio-button>
            <el-radio-button label='restrict'>
              {{$t('actions.project.settings.stretchValue.restrict')}}
            </el-radio-button>
            <el-radio-button label='smart'>
              {{$t('actions.project.settings.stretchValue.smart')}}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>
        -->
        <!-- 允许/禁止微信转发 -->
        <!--
        <el-form-item label="微信转发" class='enable-wxshare'>
          <el-radio-group theme='info' v-model='form.forbid_share'>
            <el-radio-button label='false'>
              允许
            </el-radio-button>
            <el-radio-button label='true'>
              禁止
            </el-radio-button>
          </el-radio-group>
        </el-form-item>
        -->

        <!-- 访问限制 -->
        <access-setting v-model='accessSetting' :project="project" ref='access-setting' />
      </el-tab-pane>

      <el-tab-pane label="常用设置" name='third' v-if="tbcMode">
        <!-- 微信分享 -->
        <el-form-item :label="$t('actions.project.settings.wxshare')" class='wechat-share'>
          <image-uploader v-model="cover" :title="$t('actions.project.settings.wxcover')" tag='cover' class="cover-wrapper" />
          <div class='inputs'>
            <el-input :placeholder="$t('placeholder.project.title')" v-model="form.title"></el-input>
            <el-input type="textarea" :rows='3' resize='false' :placeholder="$t('placeholder.project.description')" v-model="form.description"></el-input>
          </div>
        </el-form-item>

        <!-- 翻页箭头 -->
        <el-form-item :label="$t('actions.project.settings.arrow')">
          <el-switch class='arrow-switch' :width="35" theme='info' on-text='' off-text='' v-model="arrowMode"></el-switch>
        </el-form-item>

        <!-- 翻页控制 -->
        <el-form-item label="翻页控制" class='tansition-ctrl'>
          <el-radio-group theme='info' v-model='form.transition_ctrl'>
            <el-radio-button label='click'>
              默认手动
            </el-radio-button>
            <el-radio-button label='strict'>
              还原PPT
            </el-radio-button>
          </el-radio-group>
        </el-form-item>

        <!-- 动画控制 -->
        <el-form-item :label="$t('actions.project.settings.autoplayLabel')" class='auto-play'>
          <el-radio-group theme='info' v-model='form.auto_play'>
            <el-radio-button label='enabled'>
              {{$t('actions.project.settings.autoplay.enabled')}}
            </el-radio-button>
            <el-radio-button label='original'>
              {{$t('actions.project.settings.autoplay.original')}}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>

        <!-- 页面适配 -->
        <el-form-item :label="$t('actions.project.settings.stretch')" class='page-setup'>
          <el-radio-group theme='info' v-model='form.stretch_mode'>
            <el-radio-button label='auto'>
              {{$t('actions.project.settings.stretchValue.auto')}}
            </el-radio-button>
            <el-radio-button label='fullscreen'>
              {{$t('actions.project.settings.stretchValue.fullscreen')}}
            </el-radio-button>
            <el-radio-button label='restrict'>
              {{$t('actions.project.settings.stretchValue.restrict')}}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>

        <!-- 背景音乐 -->
        <bgm-setting v-model='bgmSetting' ref='bgm-setting' />

        <!-- 课程管理 - 时代光华特供内容 -->
        <!--
        <el-form-item label=" " v-if="project.tbc && organization && ['owner', 'admin'].indexOf(organization.role) >= 0">
          <span slot='label' class='tbcLabel'>上传至“课程管理”</span>
          <el-switch reserve class='arrow-switch' :width="35" theme='info' on-text='' off-text='' v-model="form.tbc.sync_course" :disabled="project.tbc.sync_course"></el-switch>
        </el-form-item>
        -->

        <el-form-item label="观看设置" v-if="project.tbc">
          <el-radio-group theme='info' v-model='form.tbc.public'>
            <el-radio-button :label='true'>
              公开
            </el-radio-button>
            <el-radio-button :label='false'>
              内部
            </el-radio-button>
          </el-radio-group>
          <div>
            <p class='hint' v-if='form.tbc.public'>所有人都可以通过分享出去的H5链接查看微课</p>
            <p class='hint' v-if='!form.tbc.public'>需要验证网络学院账号才可以查看微课</p>
          </div>
        </el-form-item>
      </el-tab-pane>
    </el-tabs>

    <el-form-item>
      <el-button type="primary" @click='save'>{{$t('common.buttons.save')}}</el-button>
      <el-button type="text" @click='reset'>{{$t('actions.project.settings.cancel')}}</el-button>
    </el-form-item>
  </el-form>
</div>
</template>

<style lang='scss' scoped>
$settings-width: 600px;
.setting-form {
    width: $settings-width;
    margin-left: 3 * $margin-base;
    float: left;
    text-align: left;
    position: relative;

    .tbcLabel {
        white-space: nowrap;
        position: relative;
        right: 34px;
    }

    .reupload-btn {
        position: absolute;
        right: 0;
        z-index: 1;
        color: $color-primary;

        .ppj-icon-up-big {
            margin-right: 0.4em;
        }
        &:hover {
            color: darken($color-primary, 10%);
        }
    }

    .wechat-share {
        $cover-height: 120px;

        .cover-wrapper {
            width: 120px;
            height: 120px;
            float: left;
        }

        .inputs {
            width: 100%;
            padding-left: $cover-height + $padding-base;

            & > div {
                margin-bottom: $padding-base;
                &:last-of-type {
                    margin-bottom: 0;
                }
            }
        }
    }

    .background-music {
        p {
            line-height: 1;
        }
    }
}
</style>

<i18n>
{
  "zh-cn": {
    "lockedProjectHint": "当前@:common.project为只读@:common.project，不能修改"
  }
}
</i18n>

<script>
import LogoSettingComponent from './logo.card'
import AccessSettingComponent from './access.card'
import BgmSettingComponent from './bgm.card'
import PermanentSettingComponent from './permanent.card'

let timeoutHandler = null

export default {
  data() {
    return {
      form: {
        tbc: {}
      },
      perm: null
    }
  },
  components: {
    'logo-setting': LogoSettingComponent,
    'access-setting': AccessSettingComponent,
    'bgm-setting': BgmSettingComponent,
    'permanent-setting': PermanentSettingComponent
  },
  computed: {
    project() {
      return this.$store.state.project.items[this.$route.params.id]
    },
    readonly() {
      return this.project.permissions.readonly
    },
    expired() {
      return this.project.expired_at_in_ts && this.project.expired_at_in_ts < Date.now() / 1000
    },
    locked() {
      return this.project.locked
    },
    permanent() {
      return this.project.permanent
    },
    arrowMode: {
      get() {
        return this.form.arrow_mode === 'show'
      },
      set(value) {
        this.form.arrow_mode = (value ? 'show' : 'hidden')
      }
    },
    accessSetting: {
      get() {
        return {
          type: this.form.auth_type,
          config: this.form.auth_config,
          price: this.form.pay_to_read_price
        }
      },
      set(value) {
        this.form.auth_type = value.type
        this.form.auth_config = value.config
        this.form.pay_to_read_price = value.price
      }
    },
    logoSetting: {
      get() {
        return this.form._logo || {
          type: this.form.logo,
          logo: this.form.logo_url
        }
      },
      set(value) {
        // value is object
        this.$set(this.form, '_logo', value)

        // set this.form.logo
        if (value.type === 'default') {
          this.form.logo = 'default'
        } else if (value.type === 'hide') {
          this.form.logo = null
        } else {
          this.form.logo = value.logo
        }
      }
    },
    bgmSetting: {
      get() {
        return {
          name: this.form.bgm_name,
          url: this.form.bgm_url,
          volume: this.form.bgm_volume
        }
      },
      set(value) {
        // value: {mediaId: 1, name: bgm_name}
        this.$set(this.form, 'bgm', value.mediaId)
        this.$set(this.form, 'bgm_name', value.name)
        this.$set(this.form, 'bgm_url', value.url)
        this.$set(this.form, 'bgm_volume', value.volume)
      }
    },
    cover: {
      get() {
        return this.form.cover || this.form.cover_url
      },
      set(value) {
        this.$set(this.form, 'cover', value)
      }
    }
  },
  watch: {
    project: function(value) {
      this.setData(value)
    }
  },
  mounted() {
    let vm = this
    vm.$nextTick(function() {
      if (vm.project) {
        vm.setData(vm.project)
      }
    })
  },
  methods: {
    setData(value) {
      this.form = JSON.parse(JSON.stringify(value))
    },
    save() {
      let vm = this
      if (vm.readonly) {
        vm.$alert(vm.$t('lockedProjectHint'), '注意')
        return
      }
      // force children component to hand in current data
      vm.$refs['access-setting'] && vm.$refs['access-setting'].save()
      vm.$refs['logo-setting'] && vm.$refs['logo-setting'].save()
      vm.$refs['bgm-setting'] && vm.$refs['bgm-setting'].save()

      let _save = function() {
        var ret = vm.$store.dispatch('project/update', vm.form).then(res => {
          if (vm.tbcMode) {
            window.parent.postMessage({ 'status': 'save-success' }, '*')
            return
          }
          vm.$message({
            message: '保存成功',
            type: 'success'
          })
        })
        if (vm.tbcMode) {
          var message = '服务器暂时异常，请重试操作或刷新页面'
          ret.catch(error => {
            if (error.response && error.response.status >= 400 && error.response.status !== 401) {
              message = error.response.data.message
              window.parent.postMessage({ 'status': 'save-fail', 'err-msg': message }, '*')
            }
          })
        }
      }

      // if need to unlock permanent
      if (vm.$refs['permanent-setting']) {
        vm.$refs['permanent-setting'].save().then(_save).catch(err => {
          // handle error
          console.log(err)
        })
      } else {
        _save()
      }
    },
    reset() {
      this.setData(this.project)
    }
  },
  beforeRouteLeave() {
    if (timeoutHandler) {
      clearTimeout(timeoutHandler)
      timeoutHandler = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?e97a2cda